import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const LockClosedIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/lock-closed"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M12 1.2002C9.01764 1.2002 6.59998 3.61786 6.59998 6.6002V10.8002H5.99998C4.67449 10.8002 3.59998 11.8747 3.59998 13.2002V20.4002C3.59998 21.7257 4.67449 22.8002 5.99998 22.8002H18C19.3255 22.8002 20.4 21.7257 20.4 20.4002V13.2002C20.4 11.8747 19.3255 10.8002 18 10.8002H17.4V6.6002C17.4 3.61786 14.9823 1.2002 12 1.2002ZM15.6 10.8002V6.6002C15.6 4.61197 13.9882 3.0002 12 3.0002C10.0118 3.0002 8.39998 4.61197 8.39998 6.6002V10.8002H15.6Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default LockClosedIcon;